import api from 'src/utils/ajax';

import { Faq, FaqCategory, FaqCategoryFaqResponse } from './_types';
import {
  normalizeFaq,
  normalizeFaqCategoriesResponse,
  normalizeFaqCategoryFaqResponse,
  normalizeFaqsResponse,
} from './normalizers';

import type { Identifier } from 'src/types/utilityTypes';

export const fetchFaqCategories = async (): Promise<FaqCategory[]> => {
  const response = await api.get('/api/v4/content/faqs/categories');

  return normalizeFaqCategoriesResponse(response.data);
};

export const fetchFaqCategoryFaqs = async (
  categoryId: Identifier
): Promise<FaqCategoryFaqResponse> => {
  const response = await api.get(
    `/api/v4/content/faqs/categories/${categoryId}/faq`
  );

  return normalizeFaqCategoryFaqResponse(response.data);
};

export const fetchAllFaqs = async (): Promise<Faq[]> => {
  const response = await api.get('/api/v4/content/faqs');

  return normalizeFaqsResponse(response.data);
};

export const fetchFaqBySlug = async (faqSlug: Identifier): Promise<Faq> => {
  const response = await api.get(`/api/v4/content/faqs/${faqSlug}`);

  return normalizeFaq(response.data);
};
